export class RouterConstants {

  public static readonly LOGIN = 'login';
  public static readonly PAIRING = 'pairing';
  public static readonly GUEST_LOGIN_CODE = 'quiz/:code';
  public static readonly GUEST_LOGIN = 'quiz';

  public static readonly HOME = 'home';
  public static readonly CLASSES = 'classes';

  public static readonly HOMEWORK = 'homework';
  public static readonly HOMEWORK_ID = 'homework/:id';

}
